import React from 'react';
import { makeStyles } from '@material-ui/core';
import DragHandleIcon from '@material-ui/icons/DragIndicator';
import clsx from 'clsx';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';

const useStyles = makeStyles(theme => ({
    dragHandle: {
        color: theme.palette.text.secondary,
        '&:hover, &:focus': {
            color: theme.palette.primary.main,
        },
    },
}));

export interface DragHandleProps {
    dragHandleProps: DraggableProvidedDragHandleProps,
    'aria-label': string,
    className?: string,
    icon?: React.ReactElement,
}

export const DragHandle: React.FunctionComponent<DragHandleProps> = props => {
    const classes = useStyles();
    const Icon = props.icon || DragHandleIcon;
    return (
        <span
            {...props.dragHandleProps}
            className={clsx(props.className, classes.dragHandle)}
            role="button"
            aria-label={props['aria-label']}
        >
            <Icon/>
        </span>
    );
};
